import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import classNames from 'classnames';

const styles = theme => ({
  root: {
    display: 'inline-flex',
    alignContent: 'center',
    justifyContent: 'center',
    minWidth: 48,
    height: 24,
    flexShrink: 1,
    borderRadius: theme.radius.xs,
    padding: theme.spacing(0.25),
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: '1.8',
    fontSize: '0.7em',
    textTransform: 'capitalize',
    '&[level=high]': {
      backgroundColor: theme.palette.error.main,
    },
    '&[level=medium]': {
      backgroundColor: theme.palette.warning.main,
    },
    '&[level=med]': {
      backgroundColor: theme.palette.warning.main,
    },
    '&[level=low]': {
      backgroundColor: theme.palette.facet.accentBlue,
    },
    '&[completed=true]': {
      backgroundColor: theme.palette.facet.mediumGray,
    },
  },
});

function ActionItemPriorityIndicator({
  className, classes, priority, completed,
}) {
  return (
    <span
      className={classNames(className, classes.root)}
      level={priority}
      completed={String(completed)}
    >
      {priority}
    </span>
  );
}

ActionItemPriorityIndicator.defaultProps = {
  className: '',
  completed: false,
};

ActionItemPriorityIndicator.propTypes = {
  priority: PropTypes.string.isRequired,
  completed: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles)(ActionItemPriorityIndicator);
